
const TOUR_KEY = (userId) => `tour_completed_${userId}`;

const LAST_SEEN_KEY = (userId) => `tour_last_seen_${userId}`;

const INACTIVITY_THRESHOLD_DAYS = parseInt(import.meta.env.VITE_TOUR_INACTIVITY_DAYS, 10) || 90;

export function hasTourBeenCompleted(userId) {
  return localStorage.getItem(TOUR_KEY(userId)) === 'true';
}

export function markTourCompleted(userId) {
  localStorage.setItem(TOUR_KEY(userId), 'true');
  localStorage.setItem(LAST_SEEN_KEY(userId), Date.now().toString());
}

export function shouldShowTour(userId) {
  if (!hasTourBeenCompleted(userId)) return true;
  const lastSeen = parseInt(localStorage.getItem(LAST_SEEN_KEY(userId)) ?? '0');
  const daysSince = (Date.now() - lastSeen) / (1000 * 60 * 60 * 24);
  return daysSince >= INACTIVITY_THRESHOLD_DAYS;
}


export function resetTour(userId) {
  localStorage.removeItem(TOUR_KEY(userId));
  localStorage.removeItem(LAST_SEEN_KEY(userId));
}